<script>
import { GlFormSelect, GlFormGroup } from '@gitlab/ui';
import { ValidationProvider } from 'vee-validate';
import GET_COUNTRY_LIST_QUERY from '~/graphql/queries/get_country_list.query.graphql';
import validationStateMixin from '~/javascripts/forms/validation/mixins/validation_state_mixin';

export default {
  name: 'CountrySelect',
  components: { GlFormSelect, GlFormGroup, ValidationProvider },
  mixins: [validationStateMixin],
  props: {
    initialCountry: {
      type: String,
      required: false,
      default: '',
    },
    customCountries: {
      type: Array,
      required: false,
      default: null,
    },
    groupClass: {
      type: [String, Object, Array],
      required: false,
      default: '',
    },
    useNameForValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: 'Country',
    },
    optional: {
      type: Boolean,
      required: false,
      default: false,
    },
    optionalText: {
      type: String,
      required: false,
      default: '(optional)',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      defaultCountries: [],
      selectedCountry: this.initialCountry,
    };
  },
  computed: {
    isUsingCustomCountryList() {
      return Array.isArray(this.customCountries);
    },
    countryOptions() {
      const countryList = this.isUsingCustomCountryList
        ? this.customCountries
        : this.defaultCountries;

      if (this.useNameForValue) {
        return countryList.map((country) => ({ text: country.text, value: country.text }));
      }

      return countryList;
    },
  },
  async created() {
    if (this.isUsingCustomCountryList) return;

    const { data } = await this.$apollo.query({ query: GET_COUNTRY_LIST_QUERY });
    this.defaultCountries = data.countries;
  },
  methods: {
    setCountry(country) {
      this.selectedCountry = country;
      this.$emit('change', this.selectedCountry);
    },
  },
};
</script>

<template>
  <validation-provider #default="validationContext" name="Country" rules="required" slim>
    <gl-form-group
      :class="groupClass"
      :label="label"
      label-for="country"
      :optional="optional"
      :optional-text="optionalText"
      :invalid-feedback="validationContext.errors[0]"
      :state="getValidationState(validationContext)"
    >
      <gl-form-select
        id="country"
        v-model="selectedCountry"
        data-testid="country-select"
        :options="countryOptions"
        :disabled="disabled"
        v-bind="$attrs"
        :state="getValidationState(validationContext)"
        @change="setCountry"
      >
        <template #first>
          <option value disabled selected>{{ __('Select country') }}</option>
        </template>
      </gl-form-select>
    </gl-form-group>
  </validation-provider>
</template>
